import { Injectable } from '@angular/core';
import { Link } from '../../models/class/link.class';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CardsService {
  linkSubject: BehaviorSubject<Link | undefined> = new BehaviorSubject<Link | undefined>(undefined);

  setTables(link: Link | undefined): void {
    this.linkSubject.next(link);
  }

  getHoveredLink(): Observable<Link | undefined> {
    return this.linkSubject.asObservable();
  }
}
